module.exports = __webpack_public_path__ + "img/esultanza_0.edb263e9.jpg";